import one from '../../../assets/images/about/1.png';
import two from '../../../assets/images/about/2.png';
import three from '../../../assets/images/about/3.png';
import four from '../../../assets/images/about/4.png';

export const membersData = [
  {
    image: one,
    url: '/members',
    height: '160px',
    top: 'auto',
  },
  {
    image: two,
    url: '/members',
    height: '265px'
  },
  {
    image: three,
    url: '/members',
    height: '150px',
  },
  {
    image: four,
    url: '/members',
    height: '240px',
  },
];
